/* Joeba blog TOC: dynamische thema-pills opbouwen uit mini-cards en
   filtering naar hero-rail + stadblokken. Externalized uit main-blog.liquid.

   - Country-mode (geen stad gekozen): pills uit alle hero-rail cards.
   - City-mode (.jb-city-mode-active): pills uit cards van de actieve stad.
   - Mirror naar mobiele .joeba-hero-themes balk in country-mode. */
(function(){
  var toc = document.getElementById('jbBlogToc');
  if (!toc) return;
  var list = document.getElementById('jbBlogTocList');
  var rail = document.querySelector('[data-jb-hero-rail]');
  var heroLabel = document.getElementById('joebaHeroThemesLabel');
  var heroChipsEl = document.getElementById('joebaHeroThemeChips');
  var heroBar = document.getElementById('joebaHeroThemes');
  var countryName = (function(){
    var el = document.getElementById('jbMobBcCountryLabel');
    if (el && el.textContent) return el.textContent.trim();
    var h1 = document.querySelector('.joeba-country-hero__title');
    if (h1) return h1.textContent.replace(/^.*?in\s+/i,'').trim();
    return '';
  })();
  var THEME_META = {
    'strand':{label:'Strand',emoji:'\u{1F3D6}\u{FE0F}'},
    'citytrip':{label:'Top 10',emoji:'\u{1F3D9}\u{FE0F}'},
    'culinair':{label:'Culinair',emoji:'\u{1F37D}\u{FE0F}'},
    'natuur':{label:'Natuur',emoji:'\u{1F97E}'},
    'wellness':{label:'Wellness',emoji:'\u{1F9D8}'},
    'cultuur':{label:'Cultuur',emoji:'\u{1F3DB}\u{FE0F}'},
    'wintersport':{label:'Wintersport',emoji:'\u2744\u{FE0F}'},
    'jongeren':{label:'Jongeren',emoji:'\u{1F392}'},
    'luxe':{label:'Luxe',emoji:'\u{1F451}'},
    'roadtrip':{label:'Roadtrip',emoji:'\u{1F690}'},
    'architectuur':{label:'Architectuur',emoji:'\u{1F3DB}\u{FE0F}'},
    'shoppen':{label:'Shoppen',emoji:'\u{1F6CD}\u{FE0F}'},
    'nightlife':{label:'Nightlife',emoji:'\u{1F319}'},
    'familie':{label:'Familie',emoji:'\u{1F46A}'},
    'avontuur':{label:'Avontuur',emoji:'\u{1F9D7}'}
  };
  function cap(s){ return s ? s.charAt(0).toUpperCase()+s.slice(1).replace(/-/g,' ') : s; }
  function metaFor(k){
    if (THEME_META[k]) return THEME_META[k];
    var m = k.match(/^top-(\d{1,2})$/);
    if (m) {
      var n = parseInt(m[1],10);
      var emo = n===10?'\u{1F525}':n===20?'\u{1F4CC}':n===5?'\u{1F947}':'\u{1F516}';
      return { label:'Top '+n, emoji:emo };
    }
    return { label:cap(k), emoji:'\u{1F3F7}\u{FE0F}' };
  }
  function normalizeText(s){
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[_-]+/g,' ');
  }
  function detectTopTheme(card){
    var titleEl = card.querySelector('.jb-mini-card__title, .jbx-card__title, .card__heading');
    var linkEl = card.matches('a[href]') ? card : card.querySelector('a[href]');
    var href = linkEl ? (linkEl.getAttribute('href') || '') : '';
    var title = titleEl ? titleEl.textContent : '';
    var text = normalizeText(title + ' ' + href);
    var rawHref = (href || '').toLowerCase();
    var n = 0;
    var mm = text.match(/\btop\s*(\d{1,2})\b/);
    if (mm) n = parseInt(mm[1],10);
    if (!n) { mm = rawHref.match(/[\/-]top-(\d{1,2})(?:[\/-]|\.|$)/); if (mm) n = parseInt(mm[1],10); }
    if (!n) { mm = text.match(/\b(\d{1,2})\s+(?:beste\s+)?(?:activiteiten|bezienswaardigheden|dingen|tips|hoogtepunten|highlights)\b/); if (mm) n = parseInt(mm[1],10); }
    if (!n) {
      var words = {drie:3,vier:4,vijf:5,zes:6,zeven:7,acht:8,negen:9,tien:10,elf:11,twaalf:12,dertien:13,veertien:14,vijftien:15,zestien:16,zeventien:17,achttien:18,negentien:19,twintig:20};
      Object.keys(words).some(function(w){
        var inText = new RegExp('\\b'+w+'\\s+(?:beste\\s+)?(?:activiteiten|bezienswaardigheden|dingen|tips|hoogtepunten|highlights)\\b').test(text);
        var inUrl = new RegExp('(?:^|[\\/-])(?:de[\\/-])?'+w+'[\\/-](?:beste[\\/-])?(?:activiteiten|bezienswaardigheden|dingen|tips|hoogtepunten|highlights)(?:[\\/-]|\\.|$)').test(rawHref);
        if (inText || inUrl) { n = words[w]; return true; }
        return false;
      });
    }
    if (!n || n < 3 || n > 30) return null;
    return { id:'top-'+n, label:'Top '+n };
  }
  function mergeTheme(card, id){
    var ids = (card.getAttribute('data-jb-themes') || '').split('|').filter(Boolean);
    if (/^top-\d+$/.test(id)) ids = ids.filter(function(x){ return x !== 'citytrip'; });
    if (ids.indexOf(id) === -1) ids.unshift(id);
    card.setAttribute('data-jb-themes', '|' + ids.join('|') + '|');
  }
  function addTopBadge(card, top){
    var prefix = card.classList.contains('jb-mini-card') ? 'jb-mini-card' : 'jbx-card';
    var wrap = card.querySelector('.' + prefix + '__eyebrows');
    if (!wrap && prefix === 'jbx-card') {
      var media = card.querySelector('.jbx-card__media-wrap');
      if (media) {
        wrap = document.createElement('div');
        wrap.className = 'jbx-card__eyebrows';
        media.insertBefore(wrap, media.querySelector('.jbx-card__overlay') ? media.querySelector('.jbx-card__overlay').nextSibling : media.firstChild);
      }
    }
    if (!wrap) return;
    var already = Array.prototype.some.call(wrap.querySelectorAll('.' + prefix + '__eyebrow'), function(el){ return (el.textContent || '').trim().toLowerCase() === top.label.toLowerCase(); });
    if (already) return;
    var badge = document.createElement('span');
    badge.className = prefix + '__eyebrow ' + prefix + '__eyebrow--top';
    badge.setAttribute('data-jb-top-badge', top.id);
    badge.textContent = top.label;
    wrap.insertBefore(badge, wrap.firstChild);
  }
  function enhanceTopBadges(){
    document.querySelectorAll('.jb-mini-card, .jbx-card[data-jb-city-card]').forEach(function(card){
      var top = detectTopTheme(card);
      if (!top) return;
      mergeTheme(card, top.id);
      addTopBadge(card, top);
    });
  }
  function rebuildPills(){
    if (!list) return;
    var cards = collectActiveCards();
    if (!cards.length) return;
    var counts = {};
    cards.forEach(function(c){
      var t = (c.getAttribute('data-jb-themes')||'').split('|').filter(Boolean);
      var seen = {};
      t.forEach(function(x){ if(seen[x])return; seen[x]=1; counts[x]=(counts[x]||0)+1; });
    });
    var keys = Object.keys(counts).sort(function(a,b){
      // Sorteer top-N pills bovenaan (op N descending: top-20, top-10, top-9 ...),
      // daarna overige thema's op aantal.
      var ta = /^top-(\d+)$/.exec(a), tb = /^top-(\d+)$/.exec(b);
      if (ta && tb) return parseInt(tb[1],10)-parseInt(ta[1],10);
      if (ta) return -1;
      if (tb) return 1;
      return counts[b]-counts[a];
    });
    if (!keys.length) return;
    var prevActive = (list.querySelector('.jb-blog-toc__pill.is-active')||{}).getAttribute && list.querySelector('.jb-blog-toc__pill.is-active').getAttribute('data-theme');
    if (!prevActive) prevActive = 'all';
    var html = '<button type="button" class="jb-blog-toc__pill'+(prevActive==='all'?' is-active':'')+'" data-theme="all">Alles<span class="jb-blog-toc__count" style="margin-left:6px;opacity:.7;font-size:.85em">'+cards.length+'</span></button>';
    keys.forEach(function(k){
      var meta = metaFor(k);
      html += '<button type="button" class="jb-blog-toc__pill'+(prevActive===k?' is-active':'')+'" data-theme="'+k+'"><span class="jb-blog-toc__emoji">'+meta.emoji+'</span>'+meta.label+'<span class="jb-blog-toc__count" style="margin-left:6px;opacity:.7;font-size:.85em">'+counts[k]+'</span></button>';
    });
    list.innerHTML = html;
    mirrorToHero(keys, counts, cards.length);
  }

  function isCityMode(){ return document.body.classList.contains('jb-city-mode-active'); }

  function activeCityHandle(){
    var hash = (location.hash||'').replace(/^#/,'');
    if (/^stad-/.test(hash)) return hash.replace(/^stad-/,'');
    return '';
  }

  function collectActiveCards(){
    if (isCityMode()){
      var h = activeCityHandle();
      if (h){
        var sec = document.querySelector('.joeba-blog-city[data-city-handle="'+h+'"]');
        if (sec){
          return sec.querySelectorAll('[data-jb-city-card], .blog-articles__article, .jb-mini-card');
        }
      }
    }
    return rail ? rail.querySelectorAll('.jb-mini-card') : [];
  }

  function mirrorToHero(keys, counts, total){
    // City-mode laat jbActivateCityMode de hero-chips bouwen. Wij doen
    // alleen iets in country-mode (mobiele balk boven hero-rail).
    if (!heroChipsEl || !heroBar) return;
    if (isCityMode()) return;
    if (heroLabel) heroLabel.textContent = countryName ? ("Thema's in " + countryName) : "Thema's";
    var html = '<button type="button" class="jb-hero-chip is-active" data-hero-theme="all"><span>\u2728</span>Alles<span class="jb-hero-chip__count">'+total+'</span></button>';
    keys.forEach(function(k){
      var meta = metaFor(k);
      html += '<button type="button" class="jb-hero-chip" data-hero-theme="'+k+'"><span>'+meta.emoji+'</span>'+meta.label+'<span class="jb-hero-chip__count">'+counts[k]+'</span></button>';
    });
    heroChipsEl.innerHTML = html;
    heroBar.classList.add('is-ready');
    heroChipsEl.querySelectorAll('.jb-hero-chip[data-hero-theme]').forEach(function(chip){
      chip.addEventListener('click', function(){
        var id = chip.getAttribute('data-hero-theme');
        heroChipsEl.querySelectorAll('.jb-hero-chip[data-hero-theme]').forEach(function(c){ c.classList.toggle('is-active', c===chip); });
        var tocBtn = toc.querySelector('.jb-blog-toc__pill[data-theme="'+id+'"]');
        if (tocBtn) tocBtn.click();
      });
    });
  }
  enhanceTopBadges();
  rebuildPills();

  // Expose rebuild voor externe scripts (bv. hero-swap die uit city-mode terugkomt).
  window.jbRebuildBlogTocPills = function(){
    try { rebuildPills(); } catch(e){}
    var lbl = document.querySelector('.jb-blog-toc__label--themes');
    if (lbl && !isCityMode()) lbl.textContent = "Thema's";
  };

  // Re-build pills wanneer city-mode wisselt (op body class attribute) of
  // wanneer hash naar #stad-... wijzigt (terug naar land).
  try {
    new MutationObserver(function(){ rebuildPills(); }).observe(document.body, { attributes:true, attributeFilter:['class'] });
  } catch(e){}
  window.addEventListener('hashchange', function(){ setTimeout(rebuildPills, 50); });
  window.addEventListener('load', function(){ setTimeout(rebuildPills, 200); });

  function fireCityChips(themeId){
    var sel = themeId === 'all' ? '.jb-chip[data-theme="all"]' : '.jb-chip[data-theme="'+themeId+'"]';
    document.querySelectorAll('.joeba-city-themes').forEach(function(bar){
      var chip = bar.querySelector(sel);
      if (chip) chip.click();
    });
  }
  function filterMiniCards(themeId){
    if (!rail) return;
    var allowedCities = {};
    rail.querySelectorAll('.jb-mini-card').forEach(function(c){
      if (themeId === 'all') { c.classList.remove('jb-mini-hidden'); allowedCities['*']=1; return; }
      var th = c.getAttribute('data-jb-themes')||'';
      var norm = '|' + th.replace(/^\|+|\|+$/g,'').split(/[\s|,]+/).filter(Boolean).join('|') + '|';
      var hidden = norm.indexOf('|'+themeId+'|') === -1;
      c.classList.toggle('jb-mini-hidden', hidden);
      if (!hidden){
        var ch = c.getAttribute('data-city-handle') || '';
        if (ch) allowedCities[ch] = 1;
      }
    });
    // Filter de city-tiles in de hero (Alicante/Barcelona/...) zodat alleen
    // steden zichtbaar blijven met een passend artikel.
    document.querySelectorAll('[data-jb-library-tile]').forEach(function(tile){
      if (themeId === 'all') { tile.classList.remove('is-hidden'); return; }
      var h = tile.getAttribute('data-city-handle') || '';
      tile.classList.toggle('is-hidden', !allowedCities[h]);
    });
    rail.scrollTo({left:0, behavior:'smooth'});
    if (typeof window.jbHeroRailRefresh === 'function') setTimeout(window.jbHeroRailRefresh, 60);
  }
  function filterCitiesByTheme(themeId){
    document.querySelectorAll('.joeba-blog-city').forEach(function(city){
      if (themeId === 'all') { city.style.display = ''; return; }
      var has = !!city.querySelector('.jb-chip[data-theme="'+themeId+'"]');
      city.style.display = has ? '' : 'none';
    });
  }
  function scrollToFirstMatch(){
    var bl = document.getElementById('joebaHeroBlogList');
    if (!bl) return;
    var tocH = toc.getBoundingClientRect().height || 56;
    var y = bl.getBoundingClientRect().top + window.pageYOffset - tocH - 20;
    window.scrollTo({ top: Math.max(0,y), behavior: 'smooth' });
  }
  toc.addEventListener('click', function(e){
    var btn = e.target.closest('.jb-blog-toc__pill');
    if (!btn) return;
    var id = btn.getAttribute('data-theme');
    toc.querySelectorAll('.jb-blog-toc__pill').forEach(function(p){ p.classList.toggle('is-active', p === btn); });
    filterMiniCards(id);
    var tries = 0;
    (function tryFire(){
      var ready = document.querySelector('.joeba-city-themes .jb-chip');
      if (ready || tries > 10) {
        fireCityChips(id);
        filterCitiesByTheme(id);
        scrollToFirstMatch();
        return;
      }
      tries++;
      setTimeout(tryFire, 120);
    })();
  });
})();

/* Header-offset op main-blog: compenseer de 340px body-padding van de TOC-rail
   zodat de header exact dezelfde verhoudingen houdt als bij de blogartikelen (v3). */
(function(){
  var SEL = 'sticky-header, .shopify-section-header, .header-wrapper, header.section-header, #shopify-section-header, .shopify-section-group-header-group';
  function tag(){
    var wide = window.matchMedia('(min-width: 1024px)').matches;
    var candidates = Array.prototype.slice.call(document.querySelectorAll(SEL));
    candidates.forEach(function(el){ el.classList.remove('jb-hdr-flow','jb-hdr-fixed'); });
    if (!wide) return;
    candidates.forEach(function(el){
      var nested = candidates.some(function(parent){ return parent !== el && parent.contains(el); });
      if (nested) return;
      var pos = getComputedStyle(el).position;
      el.classList.add(pos === 'fixed' ? 'jb-hdr-fixed' : 'jb-hdr-flow');
    });
  }
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(tag);
  window.addEventListener('resize', tag);
})();
